
<div class="eligibility-criteria">
    <span>Eligibility Criteria</span>
    <div [innerHTML]="eligibilityCriteria | safeHtml"></div>
</div>